<template>
  <div class="box">
    <el-alert
      title="法人创建企业后，自动成为企业管理者，并生成对应企业名称的公章，拥有员工认证管理权限"
      type="warning"
      :closable="false"
      show-icon
    >
    </el-alert>
    <div class="content">
      <div class="title">创建/加入企业</div>
      <el-autocomplete
        class="input"
        v-model.trim="name"
        :fetch-suggestions="querySearch"
        prefix-icon="el-icon-search"
        placeholder="请输入企业名称，确保与营业执照名称一致"
        :trigger-on-focus="false"
        @select="handleSelect"
      ></el-autocomplete>
      <el-button class="button" type="primary" @click="getCompanySearch"
        >下一步</el-button
      >
    </div>
  </div>
</template>
<script>
//getCompanyMatch
import { mapState, mapActions, mapGetters } from "vuex";
import mixins from "./mixins";
export default {
  mixins: [mixins],
  components: {},
  data() {
    return {
      name: "",
    };
  },
  created() {},
  computed: {},
  methods: {
    async getCompanyMatch(name) {
      const { data } = await this.$api.getCompanyMatch({ name });
      return data.map((res) => ({ ...res, value: res.name }));
    },
    async querySearch(queryString, cb) {
      const restaurants = await this.getCompanyMatch(queryString);
      cb(restaurants);
    },
    handleSelect(item) {
      console.log(item);
    },
    next() {
      this.setStep("chuangjian");
    },
    async getCompanySearch() {
      try {
        const { status, data } = await this.$api.getCompanySearch({ name: this.name });
        console.log(data);
        this.$emit("chaxunjieguo", data);
        this.setStep("jiaru1");
      } catch (error) {
        if (error.status === 404) {
          this.setStep("chuangjian");
          this.$emit("chaxunjieguo", {
            name: this.name,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  @include alertStyle;

  padding: 0 16px;
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      text-align: center;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #262626;
      margin-top: 226px;
    }
    .input {
      margin-top: 16px;
      width: 420px;
      &::v-deep {
        @include inputStyle;
      }
    }
    .button {
      margin-top: 16px;
      &::v-deep {
        @include buttonStyle2;
      }
    }
  }
}
</style>
